import API from '../services/api-config.service';
import API_STATIC from '../services/api-static-config.service';

export function getStudentProfiles(params) {
  return API({
    method: 'GET',
    url: `/student/all/pagination`,
    params
  });
}

export function toggleStudentStatus(id,payload) {
  return API({
    method: 'PUT',
    url: `/student/isactive/${id}`,
    data: JSON.stringify(payload)
  });
}

export function setDefaultPassword(payload) {
  return API({
    method: 'PUT',
    url: `/setDefaultPassword`,
    data: JSON.stringify(payload)
  });
}

export function getStudentProfile(studentId) {
  return API_STATIC({
    method: 'GET',
    url: `/student/${studentId}`,
  });
}

export function getStudentRecommendations(studentId) {
  return API_STATIC({
    method: 'GET',
    url: `/student/recommendation/${studentId}`,
  });
}

export function updateStudentProfile(studentId,payload) {
  return API({
    method: 'PUT',
    url: `/student/${studentId}`,
    data: JSON.stringify(payload)
  });
}
